export default {
    // 底部弹层样式
    rootViewStyle: {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, .6)',
        zIndex: 9999,
    },
    // 拉端半弹窗样式
    containerViewStyle: {
        position: 'fixed',
        bottom: '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        boxSizing: 'border-box',
        width: '750rpx',
        height: '500rpx',
        backgroundColor: '#FFFFFF',
        textAlign: 'center',
        borderRadius: '40 40 0 0',
    },
    // 文案样式
    titleTextStyle: {
        color: '#353535',
        fontWeight: 'bold',
        marginLeft: '79rpx',
        marginTop: '99rpx',
        fontSize: '42rpx',
        fontFamily: 'Source Han Sans CN'
    },
    imgStyle: {
        position: 'absolute',
        bottom: '343rpx',
        right: '3rpx',
        width: '309rpx',
        height: '276rpx'
    },
    iconBlockStyle: {
        position: 'absolute',
        left: '308rpx',
        top: '27rpx',
        width: '135rpx',
        height: '7rpx',
        backgroundColor: '#DBDBDB',
        borderRadius: '4rpx'
    },
    lineStyle: {
        width: '670',
        height: '1rpx',
        marginTop: '35rpx',
        marginLeft: '47rpx',
        backgroundColor: '#E5E5E5'
    },
    // 倒计时文案提示样式
    waitTextViewStyle: {
        display: 'flex',
        flexDirection: 'column',
        width: '254rpx',
        color: '#717171',
        textAlign: 'left',
        fontSize: '34rpx',
        fontWeight: '400',
        marginLeft: '81rpx',
        marginTop: '34rpx'
    },
    linkBtnBoxStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '84rpx auto 0 auto',
        width: '671rpx',
        color: '#EF8450',
    },
    twoLinkBtnStyle: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '321rpx',
        height: '67rpx',
        borderRadius: '34rpx',
        border: '2rpx solid #EF8450',
        color: '#EF8450'
    },
    singleLinkBtnStyle: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '428rpx',
        height: '77rpx',
        borderRadius: '39rpx',
        border: '2rpx solid #EF8450',
        color: '#EF8450'
    },
    wrapStyle: {
        position: 'absolute',
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        backgroundColor: 'transparent'
    },
    wxBtnStyle: {
        position: 'absolute',
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        color: '#EF8450',
        backgroundColor: 'transparent'
    },
    wxTagStyle: {
        position: 'absolute',
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        zIndex: 99999,
        color: '#EF8450',
        backgroundColor: 'transparent',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
};
